module.exports = __webpack_public_path__ + "img/send_qrcode.ad03835e.png";